import Manufacturer from "./ManufacturerList";

export default Manufacturer;
